import { memo, useCallback, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ApiStorage from '../../redux/ApiStorage';
import UserActions from '../../actions/UserActions';
import MyFlex from '../../components/myFlex/MyFlex';
import LogoSmallSVG from '../../icons/LogoSmallSVG';
import MyBadge from '../../components/badge/MyBadge';
import MySpace from '../../components/mySpace/MySpace';
import useNavigateApi from '../../appRoute/useNavigateApi';
import MyDropDown from '../../components/myDropDown/MyDropDown';
import NotificationViewModal from '../../pages/settings/notificationSettings/NotificationViewModal';
import './MenuHeader.scss';

const MenuHeader = ({ onClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigateApi = useNavigateApi();

  const refModal = useRef(null);

  const notificationCount = useSelector((state) => {
    return state.currentUser?.notificationCount;
  });

  const companyName = useSelector((state) => {
    return state.currentUser?.companyName;
  });

  const handleClick = useCallback(
    (onClick, path) => () => {
      if (onClick) onClick();
      navigateApi(path);
    },
    [navigateApi]
  );

  const handleLogOutClick = useCallback(async () => {
    await UserActions.logOut();
    if (onClick) onClick();
    ApiStorage.clearUser();
    navigate('/login');
  }, [onClick, navigate]);

  const items = useMemo(() => {
    return [
      // {
      //   key: 'csettings',
      //   label: t('WORD_COMPANY_SETTINGS'),
      //   onClick: handleClick(onClick, '/settings/company'),
      // },
      {
        key: 'gsettings',
        label: t('WORD_GENERAL_SETTINGS'),
        onClick: handleClick(onClick, '/settings/company'),
      },
      {
        type: 'divider',
      },
      {
        key: 'notif',
        label: notificationCount ? (
          <MySpace block spaceBetween>
            <div>{t('WORD_NOTIFICATIONS')}</div>
            <MyBadge status="error" />
          </MySpace>
        ) : (
          t('WORD_NOTIFICATIONS')
        ),
        onClick: handleClick(onClick, '/settings/notification'),
      },
      // {
      //   key: 'accsettings',
      //   label: t('WORD_PROFILE'),
      //   icon: <UserOutlined />,
      //   onClick: handleClick(onClick, '/settings/account'),
      // },
      {
        key: 'logout',
        label: t('WORD_LOGOUT'),
        onClick: handleLogOutClick,
      },
    ];
  }, [notificationCount, onClick, t, handleClick, handleLogOutClick]);

  return (
    <>
      <MyDropDown
        arrow={true}
        items={items}
        placement="bottom"
        className="menu_dropdown"
      >
        <MyFlex align="center" style={{ maxWidth: 210 }} block>
          <MyBadge count={notificationCount} style={{ boxShadow: 'unset' }}>
            <LogoSmallSVG />
          </MyBadge>
          <div className="menu_header_title">{companyName}</div>
        </MyFlex>
      </MyDropDown>
      <NotificationViewModal ref={refModal} />
    </>
  );
};

export default memo(MenuHeader);
